// extracted by mini-css-extract-plugin
export default {"drugResponsePageMain":"DrugResponsePage_drugResponsePageMain__E28hW"};